import Modal from "../Modal";
import Button from "../ButtonV2";
import styles from "./index.module.css";
import { backStep, setStep } from "../../store/reducers/stepReducer";
import { RootState, useAppDispatch, useAppSelector } from "../../store/store";
import {
  useGetNdaValueQuery,
  useUpdateStagesMutation,
} from "../../services/api";
import useStep from "../../hooks/useStep";
import { setStage } from "../../store/reducers/stageReducer";
import { useEffect, useState } from "react";
import useHasPermission from "../../hooks/useHasPermission";
import { tracker } from "../../services/mixpanel";

function AgreementModal() {
  const dispatch = useAppDispatch();
  const { hasPermission } = useHasPermission();
  const { setStepFunc } = useStep();
  const stage = useAppSelector((state: RootState) => state.stage);
  const zohoCustomerId = useAppSelector(
    (state: RootState) => state.login.zohoCustomerId
  );
  const [isChecked, setIsChecked] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const [updateStage] = useUpdateStagesMutation();
  const { data, isLoading } = useGetNdaValueQuery();

  const handleCheckboxChange = () => {
    tracker.steps.nda.checkbox();
    setIsChecked(!isChecked);
  };

  const handleDisagree = () => {
    tracker.steps.nda.disagree();
    dispatch(backStep());
    localStorage.clear();
  };

  const getStepFromPermissions = () => {
    if (hasPermission("video")) {
      return 2;
    }
    if (
      hasPermission("presentation") ||
      hasPermission("interactivePresentation")
    ) {
      return 3;
    }
    if (hasPermission("benefitCalculator")) {
      return 4;
    }
    return 5;
  };
  const handleClick = async () => {
    if (!isChecked) return;

    tracker.steps.nda.agree();

    const newStage = {
      ...stage,
      purlNdaChecked: Date.now().toString(),
    };
    dispatch(setStage(newStage));
    // const step = await setStepFunc(newStage);
    dispatch(setStep(getStepFromPermissions()));

    const updatedStage = await updateStage({
      zohoId: zohoCustomerId,
      key: "purlNdaChecked",
    });
  };

  useEffect(() => {
    tracker.steps.nda.pageView();
  }, []);

  return (
    <Modal show={true} onClose={() => {}}>
      <div className={styles.container}>
        {isLoading ? (
          <h1 className="text-white flex justify-center mt-12">
            <Button isLoading={isLoading} title="" variant="light6" />
          </h1>
        ) : (
          <>
            <div className={styles.modalContainer}>
              <div className={styles.modalText}>{data?.data?.title}</div>

              <div className={styles.modalDesc}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data?.data?.description as unknown as TrustedHTML,
                  }}
                  className={styles.modaldecription}
                ></div>
              </div>
            </div>
            <div className="flex items-center mt-4 mb-2 justify-end">
              <input
                type="checkbox"
                id="ndaCheckbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="ndaCheckbox" className="text-sm mx-1">
                I agree to the terms and conditions
              </label>
            </div>
            <div className={styles.modalButtonContainer}>
              <button className={styles.modalButton} onClick={handleDisagree}>
                DISAGREE
              </button>
              <div className={styles.tooltipContainer}>
                <button
                  className={`${styles.modalButton1} ${
                    !isChecked ? styles.disabled : ""
                  }`}
                  onClick={handleClick}
                  onMouseEnter={() => !isChecked && setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                >
                  AGREE
                </button>
                {showTooltip && !isChecked && (
                  <div className={styles.tooltip}>
                    Please click the box above to proceed.
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}

export default AgreementModal;
